import { Outlet, useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { PaginatedQueryPageInfoFragment, ShowPostDocument } from 'generated/resources/graphql'

import { usePaginatedQuery } from 'modules/core/hooks/usePaginatedQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import PostCard from 'modules/posts/components/PostCard'

import PostNotFound from './NotFound'
import useVistisFindOrCreate from './useVisitsFindOrCreate'

const DEFAULT_CONNECTION: {
  pageInfo: PaginatedQueryPageInfoFragment
  edges: {
    cursor: string
    node: unknown
  }[]
} = {
  pageInfo: {
    hasNextPage: false,
  },
  edges: [],
}

const ShowPost = () => {
  const id = String(useParams().id)
  const { loadingVisit } = useVistisFindOrCreate(id)
  const {
    loading: loadingPost,
    data,
    error,
    controls: { fetchMore: fetchMoreComments, hasMore: hasMoreComments },
  } = usePaginatedQuery(ShowPostDocument, {
    extractConnection: (dataToExtract) =>
      dataToExtract.posts.post?.commentsConnection ?? DEFAULT_CONNECTION,
    variables: {
      id: id,
    },
  })
  const post = data?.posts.post
  const canManagePosts = data?.posts?._policies?.postsManage?.can ?? false

  return (
    <ResponsivePage.Body loading={loadingPost || loadingVisit} error={error} showHeader={false}>
      <Box flexGrow>
        <Outlet context={{ post }} />
        {post ? (
          <PostCard
            post={post}
            fetchMoreComments={fetchMoreComments}
            hasMoreComments={hasMoreComments}
            canManagePosts={canManagePosts}
          />
        ) : (
          <PostNotFound />
        )}
      </Box>
    </ResponsivePage.Body>
  )
}

export default ShowPost
